import React from 'react';
import { theme, style } from 'constants';
import { View, Scene, AppHeader, Avatar, TimeStamp } from 'core';
import Chat from 'cont/middle/Chat';
import PmInfo from 'cont/right/PmInfo';
import { getTypingIndicatorText } from 'selectors';
import { lang } from 'lang';

const Online = selected =>
  !selected.online ? (
    ''
  ) : isNaN(selected.online) ? (
    lang.ONLINE
  ) : (
    <TimeStamp value={selected.online} only_relative style={{ fontSize: theme.sm, color: theme.gray_color_lighten(0.4) }} />
  );

const styles = style({
  chat: {
    flex: 0.6,
    borderColor: theme.gray_color_lighten(0.2),
    borderRightWidth: 0.5,
    paddingRight: 1
  }
});

const ChatContent = ({ selected, tmp_pm }) => {
  const title = (tmp_pm && tmp_pm.name) || selected.title;
  const data = tmp_pm || selected;
  return (
    <Scene>
      <AppHeader
        back
        title={title}
        title_icon={<Avatar data={data} size={40} />}
        sub_title={tmp_pm || selected.inactive ? null : getTypingIndicatorText(selected) || Online(selected)}
      />
      <Scene style={{ flexDirection: 'row' }}>
        <View style={styles.chat}>
          <Chat />
        </View>
        <View style={{ flex: 0.4 }}>
          <PmInfo />
        </View>
      </Scene>
    </Scene>
  );
};
export default ChatContent;



// WEBPACK FOOTER //
// ./src/components/middle/pm_content.web.js